<template>
  <div v-if="hasLabel" :class="parentClasses">
    <AppLabel :mode="mode" :htmlFor="id" :title="title" />
    <input
      :id="id"
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      class="form-control"
      :class="[mode === 'dark' ? 'dark-form-control' : '', classes]"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :maxlength="maxlength || null"
    />
  </div>
  <input
    v-else
    :id="id"
    :type="type"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    class="form-control"
    :class="[mode === 'dark' ? 'dark-form-control' : '', classes]"
    :placeholder="placeholder"
    :disabled="isDisabled"
    :maxlength="maxlength || null"
  />
</template>

<script>
import AppLabel from "@C/Form/AppLabel.vue";

export default {
  name: "Input",
  props: {
    mode: String,
    id: {
      type: String,
      default: "",
    },
    modelValue: [String, Number],
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    classes: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    hasLabel: {
      type: Boolean,
      default: true,
    },
    parentClasses: {
      type: String,
      default: "w-full",
    },
    maxlength: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    AppLabel,
  },
};
</script>
